export const environment = {
  production: false,
  environment: 'stage',
  oktaApp: {
    sothebysrealty: {
      redirectUri: 'https://stg-marketquest.sothebysrealty.com/implicit/callback',
      idp: '0oa7izqdvwET5bh2B1t7'
    },
    realogy: {
      redirectUri: 'https://stg-marketquest.realogy.com/implicit/callback',
      idp: '0oa7jwfrisQyf8v1f1t7'
    },
    clientId: '0oac94zlx4O6cfYaD1t7',
    issuer: 'https://realogy.okta.com/oauth2/default',
    scopes: 'https://mq-p3-api.nrtwebdev.com/api/',
    cookies: {
      secure: true
    },
    pkce: false
  },
  imagePath: 'https://abtmqsastgapps.blob.core.windows.net/',
  apiBaseUrl: ''
};
